import { ChangeEvent } from "react";
import { AuthUser } from "../../../api/common";

// Props interface
export interface RegisterProps {
	setLoggedIn: (user: AuthUser) => void;
}

// Form state interface
export interface RegisterState {
	username: string;
	firstName: string;
	lastName: string;
	password: string;
	confirmPassword: string;
	loading: boolean;
	emailError: string;
	passwordError: string;
	confirmPasswordError: string;
	error: string;
}

// Form errors interface
export interface RegisterFormErrors {
	emailError: string;
	passwordError: string;
	confirmPasswordError: string;
	error: string;
}

// Email validation pattern
export const EMAIL_PATTERN = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

// Password validation constants
export const PASSWORD_MIN_LENGTH = 8;

export interface RegisterViewModel {
	// State
	username: string;
	firstName: string;
	lastName: string;
	password: string;
	confirmPassword: string;
	loading: boolean;
	emailError: string;
	passwordError: string;
	confirmPasswordError: string;
	error: string;

	// Handlers
	handleEmailChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handlePasswordChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handleConfirmPasswordChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handleFirstNameChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handleLastNameChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
	handleSubmit: (event: { preventDefault: () => void }) => Promise<void>;
}
